<template>
  <div class="news col-md-12 col-lg-6 item">
    <h2 class="smokeheadlineh2 wow fadeInLeft news__headline">
      {{ $t("news") }}
    </h2>
    <div class="col-12 menu3">
      <div class="text-left news__content">
        <NewsItem
          v-for="(item, index) in news"
          :index="index"
          :key="index"
          :headline="item.headline"
          :subheadline="item.subheadline"
          :date="item.date"
          :teaser="item.teaser"
          :paragraphs="item.paragraphs"
          :isLastElement="index === news.length - 1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NewsItem from "./NewsItem";
import items from "@/data/news.json";
export default {
  name: "News",
  components: {
    NewsItem
  },
  computed: {
    news() {
      return items[this.$store.state.language];
    }
  }
};
</script>

<style scoped>
.news__headline {
  margin: 80px 0 50px;
  color: black;
  letter-spacing: 6px;
}
@media (max-width: 575.98px) {
  .news__headline {
    margin: 30px 0 0px;
  }
}
.news__content {
  width: 100%;
  height: auto;
  overflow: auto;
  background-color: #00aeef;
  border-radius: 20px;
  padding: 20px;
}
.menu3 {
  display: inline;
}
</style>
